import {getCookie, setCookie, deleteCookie} from './tools/cookie.js';
import Config from "./config.js";

$(function ()
{
    const spinner = $('.geolocation .result .spinner');
    const input = $('.geolocation .search');
    const inputDefault = input.data('default');

    const cookieSettings = Config.get('selectBranchCookie');

    if (cookieSettings) {
        // koukneme, jestli máme v cookies uloženou pobočku, na kterou budeme dělat redirect
        let cookie = getCookie(cookieSettings.name);

        // pokud máme v cookie číslo, odstraníme (dříve jsme ukládali ID pobočky)
        if (/^\d+$/.test(cookie)) {
            deleteCookie(cookieSettings.name);
            cookie = undefined;
        }

        // nesmíme mít v settings storeRedirect, to by znamenalo, že aktuálně na pobočce jsme
        if (cookie && !cookieSettings.storeRedirect) {
            // Simulate an HTTP redirect
            window.location.replace(cookie);
        }
    }

    let searchTimeout;

    $('.branch-select-city').on('click', function(e) {
        let target = $(e.target);

        // chceme jít z pobočky zpět na stránku /obchodník-letáky?
        if (cookieSettings && target.hasClass('branch-clear')) {
            let redirectUrl = cookieSettings.storeRedirect;

            // pokud je v cookie hlavního obchodu uložena pobočka podobchodu, smažeme ji taky
            if ((cookieSettings.name !== cookieSettings.mainStoreName)
                && (getCookie(cookieSettings.name) === getCookie(cookieSettings.mainStoreName))
            ) {
                // pokud jsme na pobočku šli z hlavního obchodu, redirect bude právě na něj
                redirectUrl = cookieSettings.mainStoreRedirect;
                deleteCookie(cookieSettings.mainStoreName);
            }

            // z cookies smažeme a uděláme redirect na obchod
            deleteCookie(cookieSettings.name);

            window.location.replace(redirectUrl);
        }
        else {
            // Pokud máme defaultní hodnotu, do inputu nastavíme a nasimulujeme keyup pro vyhledávání.
            if (inputDefault) {
                input.val(inputDefault);
                input.keyup();
            }
        }
    });

    // našeptávač
    input.keyup(function() {

        const query = $(this).val();
        const link = $('.geolocation').data('link');

        const body = $('.geolocation .result .body');

        // pokud je query prázné, nepošleme ajax a vyčistíme body
        if (query.length === 0)
        {
            body.remove();
            return;
        }

        // request pošleme až po 1 sekundě, kdy nechodí znaky z inputu
        clearTimeout(searchTimeout);

        let data = {
            'selectboxBranches-query': query
        };

        // Budeme posílat pouze napoprvé.
        if (input.attr('data-default-city-id')) {
            data["selectboxBranches-defaultCityId"] = input.attr('data-default-city-id');
        }

        searchTimeout = setTimeout(function() {
            $.nette.ajax({
                url: link,
                data: data,
                start: function () {
                    body.remove();
                    spinner.show();
                },
                complete: function () {
                    spinner.hide();
                    initBranchHandle();

                    // Defaultní hodnoty budeme chtít zobrazit jen při prvním načtení, při další úpravě query už zohledňovat nechceme.
                    // Proto po prvním zadání dat smažeme defaultní ID města.
                    input.attr('data-default-city-id', null);
                }
            });
        }, 1000);
    });

    // geo vyhledávač
    $('.geolocation .gps').on('click', function() {

        dataLayer.push({
            "event": "action_click",
            "action": {
                "name": "geolocation",
                "type": "click",
                "value": "nearest",
            },
            _clear: true,
        });

        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {

                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                const link = $('.geolocation .gps').data('link');

                const body = $('.geolocation .result .body');

                $.nette.ajax({
                    url: link,
                    data: {
                        'selectboxBranches-latitude': latitude,
                        'selectboxBranches-longitude': longitude
                    },
                    start: function () {
                        body.remove();
                        spinner.show();
                    },
                    complete: function () {
                        spinner.hide();
                        initBranchHandle();
                    }
                });
            });
        }
        else {
            $('.geolocation .result').html('Geolocation is not supported by this browser.');
        }
    });

    $('.geo-icon-header').click(function () {
        $('.geolocation-input-wrapper').toggleClass('geolocation-input-wrapper--visible');
        $('.geolocation-input-wrapper input.search').focus().click();
    });
});

function initBranchHandle() {
    // handle na prokliknutí pobočky z modálního okna
    $('.geolocation .result a').on('click', function() {
        setCookie('store-' + $(this).data('store'), $(this).attr('href'), 365);

        let mainStoreId = $(this).data('main-store');
        mainStoreId = mainStoreId ? mainStoreId : null;

        // pokud ukládáme cookie pro pobočku podobchodu, uložíme cookie i pro hlavní obchod
        // pokud již taková cookie existuje - nevadí, přepíšeme, chceme mít poslední zvolený podobchod
        if (mainStoreId !== null && ($(this).data('store') !== mainStoreId)) {
            setCookie('store-' + mainStoreId, $(this).attr('href'), 365);
        }
    });
}
